import React from 'react'
import { connect } from 'react-redux'
import PendingInvitations from './PendingInvitations'
import Calendars from './Calendars'

function SidePanel(props){
  const { calendars, invitations, current_user } = props
  
	return(
		<div className="col-xs-12 col-lg-3 d-xs-block d-lg-inline-block h-100 pt-3" style={{borderRight: '1px solid rgba(0,0,0,0.1)', overflowY: 'scroll'}}>
      <a 
        className="m-1 btn btn-sm btn-primary d-block text-align-center" 
        href={`new_calendar`}>
        Create New Calendar
      </a>
      { invitations.length > 0 && <PendingInvitations invitations={invitations}/> }
      <Calendars calendars={calendars} current_user={current_user}/>
    </div>
	)
}


const mapStateToProps = (state, ownProps) => {
  return {
    calendars: state.calendars,
    invitations: state.invitations,
    current_user: state.current_user,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SidePanel);